export const preload = src => new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = resolve
    img.onerror = reject
    img.src = src
})

const preloadAll = srcs => Promise.all(srcs.map(preload));

export default preloadAll;